// Routes de proximité (lot L5-C1, M17), raccordées dans Application.tsx par une seule ligne.
import type { RouteObject } from 'react-router';
import { PageBesoin } from './PageBesoin';
import { PageProximite } from './PageProximite';
import { PageQuartier } from './PageQuartier';

export const routesProximite: RouteObject[] = [
  { path: '/proximite', element: <PageProximite /> },
  { path: '/proximite/quartiers/:id', element: <PageQuartier /> },
  { path: '/proximite/besoins/:id', element: <PageBesoin /> },
];
